import Cookies from 'js-cookie';

import { Session, SessionOptions, BrowserSessionWidget } from '../core';

function getLanguageFromCookie() {
  const language = Cookies.get('user-language');

  return language || 'en';
}

function getSettingsByLangCode(language: string): SessionOptions {
  const setting = window.sessionInitInfo;
  const sessionOptions = setting as SessionOptions;
  sessionOptions.url_id = setting.url_id ? getUrlIdByLanguage(setting.url_id, language) : ''
  return sessionOptions;
}

function getUrlIdByLanguage(url_id: Record<string, string>, lang: string): string | undefined {
  return url_id[lang] || url_id['en'];
}

const session = new Session(window?.sessionDataLayer);
const options = getSettingsByLangCode(getLanguageFromCookie());
window.session = window.session || { initialize: session.initialize };
window.session.initialize(new BrowserSessionWidget(options));
